import JSONbig from 'json-bigint'
import { API_BASE } from './config.js'

const jsonParser = JSONbig({ storeAsString: true })

function getToken() {
  return localStorage.getItem('token') || ''
}

function request(method, path, body) {
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + getToken()
  }
  const options = {
    method,
    headers,
    credentials: 'include'
  }
  if (body !== undefined) {
    options.body = JSON.stringify(body)
  }
  return fetch(`${API_BASE}${path}`, options)
    .then(res => res.text())
    .then(text => jsonParser.parse(text))
}

/**
 * 查询好友列表
 * @returns {Promise<{code:number,message:string,data:Array,success:boolean,timestamp:string}>}
 */
export function listFriends() {
  return request('GET', '/api/v1/friends')
}

/**
 * 查询全部好友的当前动态（正在做什么 / 上一次做了什么）。
 *
 * 好友列表昵称下方那一行就是用这里的数据：只统计对我可见的工作表，
 * 没有动态的好友不会出现在结果里，前端按 friendId 挂到对应列表行。
 *
 * @returns {Promise<{code:number,message:string,data:Array<{
 *   friendId:string, status:'RUNNING'|'FINISHED', content:string,
 *   projectName:string, projectId:string, startTime:string, endTime:string|null
 * }>,success:boolean,timestamp:string}>}
 */
export function listFriendActivities() {
  return request('GET', '/api/v1/friends/activities')
}

/**
 * 查询好友申请列表
 * @param {string} [type] INCOMING 收到的 / OUTGOING 发出的
 * @returns {Promise<{code:number,message:string,data:Array,success:boolean,timestamp:string}>}
 */
export function listFriendRequests(type) {
  const query = new URLSearchParams({ type: type || 'INCOMING' }).toString()
  return request('GET', `/api/v1/friends/requests?${query}`)
}

/**
 * 搜索用户（按昵称或邮箱）
 * @param {string} keyword 关键词
 * @returns {Promise<{code:number,message:string,data:Array,success:boolean,timestamp:string}>}
 */
export function searchUsers(keyword) {
  const query = new URLSearchParams({ keyword }).toString()
  return request('GET', `/api/v1/friends/search?${query}`)
}

/**
 * 发起好友申请
 * @param {string|number} userId 对方用户 ID
 * @param {Object} [params]
 * @param {string} [params.remark] 备注名
 * @returns {Promise<{code:number,message:string,data:null,success:boolean,timestamp:string}>}
 */
export function sendFriendRequest(userId, params) {
  return request('POST', `/api/v1/friends/${userId}`, params || {})
}

/**
 * 同意好友申请
 * @param {string|number} userId 对方用户 ID
 * @param {Object} [params]
 * @param {string} [params.remark] 备注名
 * @returns {Promise<{code:number,message:string,data:null,success:boolean,timestamp:string}>}
 */
export function acceptFriendRequest(userId, params) {
  return request('PUT', `/api/v1/friends/${userId}/accept`, params || {})
}

/**
 * 拒绝好友申请
 * @param {string|number} userId 对方用户 ID
 * @returns {Promise<{code:number,message:string,data:null,success:boolean,timestamp:string}>}
 */
export function rejectFriendRequest(userId) {
  return request('PUT', `/api/v1/friends/${userId}/reject`)
}

/**
 * 删除好友（也可撤回自己发出的申请）
 * @param {string|number} userId 好友用户 ID
 * @returns {Promise<{code:number,message:string,data:null,success:boolean,timestamp:string}>}
 */
export function removeFriend(userId) {
  return request('DELETE', `/api/v1/friends/${userId}`)
}
